import { Box, Card, Typography } from "@mui/joy";
import { ChevronRight } from "lucide-react";

import { env } from "../../config";
import { Button } from "../../shared";

import brandMark from "../../assets/images/logo.png";
import loginWelcomeArt from "../../assets/images/login-2.png";

const LOGIN_URL = `${env.API_ENDPOINT}/v1/auth/external/cognito`;

export default function Login() {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                minHeight: "100vh",
            }}
        >
            <Box
                flex={1}
                display={"flex"}
                alignItems={"center"}
                flexDirection={"column"}
                height={"100%"}
            >
                <Box
                    width={"100%"}
                    margin={"auto"}
                    maxWidth={400}
                    px={{ xs: 4, md: 0 }}
                    py={{ xs: 8, md: 0 }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.25,
                            mb: 1.5,
                        }}
                    >
                        <Box
                            component="img"
                            src={brandMark}
                            alt="Roof in Motion"
                            sx={{
                                width: 40,
                                height: 40,
                                objectFit: "contain",
                            }}
                        />
                        <Typography level="h4" sx={{ m: 0 }}>
                            Roof in Motion
                        </Typography>
                    </Box>
                    <Typography level="h3" sx={{ maxWidth: 300 }}>
                        We handle the chaos—so you can build with confidence.
                    </Typography>
                    <Box mt={3}>
                        <a href={LOGIN_URL}>
                            <Button
                                loadingPosition={"start"}
                                sx={{ mt: 1 }}
                                endDecorator={<ChevronRight size={16} />}
                            >
                                Get to Work
                            </Button>
                        </a>

                        <Typography sx={{ mt: 2 }}>
                            Just getting started? We've got intro videos to help
                            you hit the ground running.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Box
                flex={1}
                display={{ xs: "none", md: "flex" }}
                alignItems={"center"}
                px={2}
            >
                <Card
                    variant="soft"
                    sx={{
                        width: "100%",
                        maxWidth: "90%",
                        flex: 1,
                        height: "90vh",
                        p: 0,
                        display: "flex",
                        background: "#eeeff1",
                        overflow: "hidden",
                        position: "relative",
                    }}
                >
                    <Box
                        component="img"
                        src={loginWelcomeArt}
                        alt="Roof"
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            objectPosition: "center",
                            display: "block",
                        }}
                    />
                </Card>
            </Box>
        </Box>
    );
}
